import { Injectable } from '@angular/core';

import { User } from './user';

import { HttpAuthenticationService } from './http-authentication.service';
import { NotificationService } from '../shared/notification/notification.service';

// A shared user service that contain the actually logged in user details

@Injectable()
export class LocalUserService {

	public user: User = new User();
	
	public new_user_mail: String;

	constructor(private auth: HttpAuthenticationService,
		private notificationService: NotificationService) {}

	getSignedInUser(callback=null){

		this.auth.getSignedInUser()
			.subscribe(
				signedUser => {

					signedUser.password = null;
					this.user = signedUser;
					if(callback){
						callback();
					}
				},
				error => {

					this.notificationService.danger(error, "<b>Erreur lors de la récupération des données utilisateur!</b>");
				})
	}

	updateProfile() {

		this.auth.updateUserInfos(this.user)
			.subscribe(
				updated_user => {

					updated_user.password = null;
					this.user = updated_user;
					this.notificationService.success("<b>Mise à jour effectuée!</b>");
				},
				error => {

					this.notificationService.danger(error, "<b>Erreur lors de la mis à jour utilisateur!</b>");
				})
	}

	getDatatableLanguage() {

		return {
			"decimal": "",
			"emptyTable": "Pas de données disponible",
			"info": "Affichant _START_ à _END_ de _TOTAL_ enregistrements",
			"infoEmpty": "0 enregistrements",
			"infoFiltered": "(filtered from _MAX_ total entries)",
			"infoPostFix": "",
			"thousands": ",",
			"lengthMenu": "Elements par page _MENU_",
			"loadingRecords": "Chargement...",
			"processing": "Chargement...",
			"search": "Filtrer : ",
			"searchPlaceholder": "Terme de recherche",
			"zeroRecords": "Pas d'enregistrement trouvé",
			"paginate": {
				"first": "Premier",
				"last": "Dernier",
				"next": "Suivant",
				"previous": "Précédent"
			},
			"aria": {
				"sortAscending": ": Trier par ordre croissant",
				"sortDescending": ": Trier par ordre décroissant"
			}
		};
	}
}


// WEBPACK FOOTER //
// ./src/app/authentication/local-user.service.ts